[
  {
    "name": "United States",
    "abbreviation": "US",
    "states": [
      {
        "name": "Alabama",
        "abbreviation": "AL",
        "type": "state",
        "contiguous": true
      },
      {
        "name": "Alaska",
        "abbreviation": "AK",
        "type": "state",
        "contiguous": false
      },
      {
        "name": "American Samoa",
        "abbreviation": "AS",
        "type": "territory",
        "contiguous": false
      },
      {
        "name": "Arizona",
        "abbreviation": "AZ",
        "type": "state",
        "contiguous": true
      },
      {
        "name": "Arkansas",
        "abbreviation": "AR",
        "type": "state",
        "contiguous": true
      },
      {
        "name": "California",
        "abbreviation": "CA",
        "type": "state",
        "contiguous": true
      },
      {
        "name": "Colorado",
        "abbreviation": "CO",
        "type": "state",
        "contiguous": true
      },
      {
        "name": "Connecticut",
        "abbreviation": "CT",
        "type": "state",
        "contiguous": true
      },
      {
        "name": "Delaware",
        "abbreviation": "DE",
        "type": "state",
        "contiguous": true
      },
      {
        "name": "District Of Columbia",
        "abbreviation": "DC",
        "type": "district",
        "contiguous": true
      },
      {
        "name": "Federated States Of Micronesia",
        "abbreviation": "FM",
        "type": "associated_state",
        "contiguous": false
      },
      {
        "name": "Florida",
        "abbreviation": "FL",
        "type": "state",
        "contiguous": true
      },
      {
        "name": "Georgia",
        "abbreviation": "GA",
        "type": "state",
        "contiguous": true
      },
      {
        "name": "Guam",
        "abbreviation": "GU",
        "type": "territory",
        "contiguous": false
      },
      {
        "name": "Hawaii",
        "abbreviation": "HI",
        "type": "state",
        "contiguous": false
      },
      {
        "name": "Idaho",
        "abbreviation": "ID",
        "type": "state",
        "contiguous": true
      },
      {
        "name": "Illinois",
        "abbreviation": "IL",
        "type": "state",
        "contiguous": true
      },
      {
        "name": "Indiana",
        "abbreviation": "IN",
        "type": "state",
        "contiguous": true
      },
      {
        "name": "Iowa",
        "abbreviation": "IA",
        "type": "state",
        "contiguous": true
      },
      {
        "name": "Kansas",
        "abbreviation": "KS",
        "type": "state",
        "contiguous": true
      },
      {
        "name": "Kentucky",
        "abbreviation": "KY",
        "type": "state",
        "contiguous": true
      },
      {
        "name": "Louisiana",
        "abbreviation": "LA",
        "type": "state",
        "contiguous": true
      },
      {
        "name": "Maine",
        "abbreviation": "ME",
        "type": "state",
        "contiguous": true
      },
      {
        "name": "Marshall Islands",
        "abbreviation": "MH",
        "type": "associated_state",
        "contiguous": false
      },
      {
        "name": "Maryland",
        "abbreviation": "MD",
        "type": "state",
        "contiguous": true
      },
      {
        "name": "Massachusetts",
        "abbreviation": "MA",
        "type": "state",
        "contiguous": true
      },
      {
        "name": "Michigan",
        "abbreviation": "MI",
        "type": "state",
        "contiguous": true
      },
      {
        "name": "Minnesota",
        "abbreviation": "MN",
        "type": "state",
        "contiguous": true
      },
      {
        "name": "Mississippi",
        "abbreviation": "MS",
        "type": "state",
        "contiguous": true
      },
      {
        "name": "Missouri",
        "abbreviation": "MO",
        "type": "state",
        "contiguous": true
      },
      {
        "name": "Montana",
        "abbreviation": "MT",
        "type": "state",
        "contiguous": true
      },
      {
        "name": "Nebraska",
        "abbreviation": "NE",
        "type": "state",
        "contiguous": true
      },
      {
        "name": "Nevada",
        "abbreviation": "NV",
        "type": "state",
        "contiguous": true
      },
      {
        "name": "New Hampshire",
        "abbreviation": "NH",
        "type": "state",
        "contiguous": true
      },
      {
        "name": "New Jersey",
        "abbreviation": "NJ",
        "type": "state",
        "contiguous": true
      },
      {
        "name": "New Mexico",
        "abbreviation": "NM",
        "type": "state",
        "contiguous": true
      },
      {
        "name": "New York",
        "abbreviation": "NY",
        "type": "state",
        "contiguous": true
      },
      {
        "name": "North Carolina",
        "abbreviation": "NC",
        "type": "state",
        "contiguous": true
      },
      {
        "name": "North Dakota",
        "abbreviation": "ND",
        "type": "state",
        "contiguous": true
      },
      {
        "name": "Northern Mariana Islands",
        "abbreviation": "MP",
        "type": "territory",
        "contiguous": false
      },
      {
        "name": "Ohio",
        "abbreviation": "OH",
        "type": "state",
        "contiguous": true
      },
      {
        "name": "Oklahoma",
        "abbreviation": "OK",
        "type": "state",
        "contiguous": true
      },
      {
        "name": "Oregon",
        "abbreviation": "OR",
        "type": "state",
        "contiguous": true
      },
      {
        "name": "Palau",
        "abbreviation": "PW",
        "type": "associated_state",
        "contiguous": false
      },
      {
        "name": "Pennsylvania",
        "abbreviation": "PA",
        "type": "state",
        "contiguous": true
      },
      {
        "name": "Puerto Rico",
        "abbreviation": "PR",
        "type": "territory",
        "contiguous": false
      },
      {
        "name": "Rhode Island",
        "abbreviation": "RI",
        "type": "state",
        "contiguous": true
      },
      {
        "name": "South Carolina",
        "abbreviation": "SC",
        "type": "state",
        "contiguous": true
      },
      {
        "name": "South Dakota",
        "abbreviation": "SD",
        "type": "state",
        "contiguous": true
      },
      {
        "name": "Tennessee",
        "abbreviation": "TN",
        "type": "state",
        "contiguous": true
      },
      {
        "name": "Texas",
        "abbreviation": "TX",
        "type": "state",
        "contiguous": true
      },
      {
        "name": "Utah",
        "abbreviation": "UT",
        "type": "state",
        "contiguous": true
      },
      {
        "name": "Vermont",
        "abbreviation": "VT",
        "type": "state",
        "contiguous": true
      },
      {
        "name": "Virgin Islands",
        "abbreviation": "VI",
        "type": "territory",
        "contiguous": false
      },
      {
        "name": "Virginia",
        "abbreviation": "VA",
        "type": "state",
        "contiguous": true
      },
      {
        "name": "Washington",
        "abbreviation": "WA",
        "type": "state",
        "contiguous": true
      },
      {
        "name": "West Virginia",
        "abbreviation": "WV",
        "type": "state",
        "contiguous": true
      },
      {
        "name": "Wisconsin",
        "abbreviation": "WI",
        "type": "state",
        "contiguous": true
      },
      {
        "name": "Wyoming",
        "abbreviation": "WY",
        "type": "state",
        "contiguous": true
      }
    ]
  },
  {
    "name": "Canada",
    "abbreviation": "CA",
    "states": [
      {
        "name": "Alberta",
        "abbreviation": "AB",
        "type": "province",
        "contiguous": true
      },
      {
        "name": "British Columbia",
        "abbreviation": "BC",
        "type": "province",
        "contiguous": true
      },
      {
        "name": "Manitoba",
        "abbreviation": "MB",
        "type": "province",
        "contiguous": true
      },
      {
        "name": "New Brunswick",
        "abbreviation": "NB",
        "type": "province",
        "contiguous": true
      },
      {
        "name": "Newfoundland and Labrador",
        "abbreviation": "NL",
        "type": "province",
        "contiguous": true
      },
      {
        "name": "Northwest Territories",
        "abbreviation": "NT",
        "type": "territory",
        "contiguous": true
      },
      {
        "name": "Nova Scotia",
        "abbreviation": "NS",
        "type": "province",
        "contiguous": true
      },
      {
        "name": "Nunavut",
        "abbreviation": "NU",
        "type": "territory",
        "contiguous": true
      },
      {
        "name": "Ontario",
        "abbreviation": "ON",
        "type": "province",
        "contiguous": true
      },
      {
        "name": "Prince Edward Island",
        "abbreviation": "PE",
        "type": "province",
        "contiguous": false
      },
      {
        "name": "Quebec",
        "abbreviation": "QC",
        "type": "province",
        "contiguous": true
      },
      {
        "name": "Saskatchewan",
        "abbreviation": "SK",
        "type": "province",
        "contiguous": true
      },
      {
        "name": "Yukon Territory",
        "abbreviation": "YT",
        "type": "territory",
        "contiguous": true
      }
    ]
  }
]
